import { setUserCardOpened } from './actions';
import { trackOpenUserCard } from './tracking';
import { fetchUserProfileThunk } from '../userProfile';
import { currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';
import { isSpecialistSelector } from '../../selectors/isSpecialistSelector';
import { TThunkAction } from '../../types/redux/thunk';

export const openUserCard =
  (userId: number): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();

    const currentChat = currentOpenChatSelector(state);
    const opponentId = currentChatOpponentIdSelector(state);
    const isSpecialist = isSpecialistSelector(state);

    dispatch(setUserCardOpened());

    if (currentChat && isSpecialist) {
      dispatch(fetchUserProfileThunk(currentChat.chatId));
    }

    trackOpenUserCard(currentChat, userId, opponentId);
  };
